import { Component } from "@angular/core";
import { NotificationService } from "app/service/notification.service";

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.css'],
    host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' }
})
export class ToastComponent {

    //#region Constructor

    constructor(public notificationService: NotificationService) { }

    //#endregion
}